export default "Museum Obscurum er en udstilling, som er en del af Museum Lolland-Falster. De åbnede deres escape room i starten af 2019.";